module.exports = __webpack_public_path__ + "media/marketing_campaigns/channels-a7f3b5f8.svg";